import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import "./stylesFreeBetModal.css";

import { CloseOutlined } from "@ant-design/icons";
import { message } from "antd";

import { AppStrings } from "../../../../../utils/constants/AppStrings";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import FeatureFlagService from "../../../../../services/FeatureFlagService";
import { SPORTSBOOK_PROVIDERS_INNER_FLAGS } from "../../../../../utils/Constants";

const FreeBetModal = forwardRef(({ handleCancel, data }, ref) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [hasSportsbookProvider, setHasSportsbookProvider] = useState(false);
  const [formData, setFormData] = useState({
    amount: "",
    exp_time_format: "hours",
    exp_time: "",
    reason: "",
  });

  // Check feature flags for available providers
  useEffect(() => {
    const checkProviders = async () => {
      await FeatureFlagService.initialize();

      // Check if any sportsbook provider is enabled
      const hasSportsbook = SPORTSBOOK_PROVIDERS_INNER_FLAGS.some((provider) =>
        FeatureFlagService.isEnabled(provider),
      );
      setHasSportsbookProvider(hasSportsbook);
    };
    checkProviders();
  }, []);

  useEffect(() => {
    if (data) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        user_id: data.user_id,
      }));
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "amount") {
      if (value === "" || /^\d+(\.\d{0,2})?$/.test(value)) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
      return;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const clearForm = () => {
    setFormData({
      user_id: data.user_id,
      amount: "",
      exp_time_format: "hours",
      exp_time: "",
      reason: "",
    });
    setIsApiRunning(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsApiRunning(true);

    const params = {
      user_id: formData.user_id,
      amount: formData.amount,
      exp_time_format: formData.exp_time_format,
      exp_time: formData.exp_time,
      reason: formData.reason,
      type: "sportsbook",
    };

    try {
      await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GIVE_USER_FREE_PICK?.replace("{user_id}", params?.user_id),
        params,
      );

      message.success(AppStrings.FREE_BET_ADDED_SUCCESSFULLY);
    } catch (error) {
      console.error("Error in setting free cash:", error);
      message.error(AppStrings.ERROR_PROCESSING_REQUEST);
    } finally {
      setIsApiRunning(false);
      handleCancel();
    }
  };

  useImperativeHandle(ref, () => ({
    clearForm,
  }));

  return (
    <div className="free-bet-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title"> {AppStrings.FREE_BET}</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="free-bets-body">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="amount">{AppStrings.AMOUNT}:</label>
            <input
              type="text"
              id="amount"
              name="amount"
              placeholder="#"
              min="0"
              inputMode="decimal"
              onWheel={(e) => e.target.blur()}
              value={formData.amount}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="reason">{AppStrings.REASON}:</label>
            <input
              type="text"
              id="reason"
              name="reason"
              placeholder="Leave a comment"
              value={formData.reason}
              onChange={handleChange}
              required
            />
          </div>
          <div className="free-bet-expiration-container">
            <div className="form-group">
              <label htmlFor="exp_time_format">
                {AppStrings.EXPIRATION_TIME_FORMAT}:
              </label>
              <select
                id="exp_time_format"
                name="exp_time_format"
                value={formData.exp_time_format}
                onChange={handleChange}
              >
                <option value="hours">{AppStrings.HOURS}</option>
                <option value="days">{AppStrings.DAYS}</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="exp_time">{AppStrings.EXPIRATION_TIME}:</label>
              <input
                type="number"
                id="exp_time"
                name="exp_time"
                min="0"
                onWheel={(e) => e.target.blur()}
                value={formData.exp_time}
                onChange={handleChange}
                required
                style={{ height: "41px" }}
              />
            </div>
          </div>
          <button
            type="submit"
            className={`${isApiRunning ? "button-sending" : ""}`}
            disabled={isApiRunning || !hasSportsbookProvider}
          >
            {isApiRunning ? (
              <RebetLoader height={"50px"} width={"50px"} />
            ) : (
              AppStrings.ADD_FREE_BET
            )}
          </button>
        </form>
      </div>
    </div>
  );
});

export default FreeBetModal;
